import IsAuthenticated from '@/components/middleware/isAuthenticated'
import {
  ApplicationDetails,
  Applications,
  Dashboard,
  Orders,
  Vendors,
  UserManagement,
  NotFound,
  HelpCenter,
  VendorDetails,
  Withdrawals,
  CustomerWaitingList,
  VendorWaitingList,
  Refunds,
  PaymentsList,
  Delivery,
  CompletedDeliveries,
  LiveDeliveryTracking,
  CustomerDetails,
  CommissionManagement,
  CommissionsList,
  CustomerTransactions,
  VendorTransactions,
  Complaints,
} from '@/pages'
import ForgotPasswordPage from '@/pages/auth/forgot-password'
import Login from '@/pages/auth/login'
import OTPVerificationPage from '@/pages/auth/otp-verification'
import ResetPasswordPage from '@/pages/auth/reset-password'
import Customers from '@/pages/protected/customers'
import Payments from '@/pages/protected/payments'
import Settings from '@/pages/protected/settings'
import routesPath from '@/utils/routesPath'
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Toaster } from 'sonner'

const {
  DASHBOARD,
  ORDERS,
  VENDORS,
  LOGIN,
  FORGOT_PASSWORD,
  OTP_VERIFICATION,
  RESET_PASSWORD,
  APPLICATIONS,
  USER_MANAGEMENT,
  HELP_CENTER,
  WIDTHDRAWALS,
  SETTINGS,
  VENDOR_LIST,
  CUSTOMER_LIST,
  CUSTOMERS,
  REFUNDS,
  PAYMENTS,
  PAYMENTS_LIST,
  DELIVERY,
  COMPLETED_DELIVERIES,
  LIVE_DELIVERY_TRACKING,
  COMMISSIONS,
  COMMISSIONS_LIST,
  COMPLAINTS,
  CUSTOMER_TRANSACTIONS,
  VENDOR_TRANSACTIONS,
} = routesPath
export default function AppRoute() {
  return (
    <Suspense>
      <Routes>
        {/* <Route index path='/' element={<Home />} /> */}
        <Route index path={LOGIN} element={<Login />} />
        <Route path={FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route path={OTP_VERIFICATION} element={<OTPVerificationPage />} />
        <Route path={RESET_PASSWORD} element={<ResetPasswordPage />} />
        <Route element={<IsAuthenticated />}>
          <Route path={DASHBOARD} element={<Dashboard />} />
          <Route path={ORDERS} element={<Orders />} />
          <Route path={WIDTHDRAWALS} element={<Withdrawals />} />
          <Route path={REFUNDS} element={<Refunds />} />
          <Route path={COMMISSIONS} element={<CommissionManagement />} />
          <Route path={COMMISSIONS_LIST} element={<CommissionsList />} />
          <Route
            path={CUSTOMER_TRANSACTIONS}
            element={<CustomerTransactions />}
          />
          <Route
            path={VENDOR_TRANSACTIONS}
            element={<VendorTransactions />}
          />
          <Route path={PAYMENTS} element={<Payments />} />
          <Route path={PAYMENTS_LIST} element={<PaymentsList />} />
          <Route path={DELIVERY} element={<Delivery />} />
          <Route
            path={COMPLETED_DELIVERIES}
            element={<CompletedDeliveries />}
          />
          <Route
            path={LIVE_DELIVERY_TRACKING}
            element={<LiveDeliveryTracking />}
          />
          <Route path={VENDORS} element={<Vendors />} />
          <Route path={CUSTOMERS} element={<Customers />} />
          <Route path={`${VENDORS}/:id`} element={<VendorDetails />} />
          <Route path={`${CUSTOMERS}/:id`} element={<CustomerDetails />} />
          <Route path={APPLICATIONS} element={<Applications />} />
          <Route
            path={`${APPLICATIONS}/:id`}
            element={<ApplicationDetails />}
          />
          <Route path={USER_MANAGEMENT} element={<UserManagement />} />
          <Route path={COMPLAINTS} element={<Complaints />} />
          <Route path={HELP_CENTER} element={<HelpCenter />} />
          <Route path={SETTINGS} element={<Settings />} />
          <Route path={VENDOR_LIST} element={<VendorWaitingList />} />
          <Route path={CUSTOMER_LIST} element={<CustomerWaitingList />} />
        </Route>
        {/* Catch-all route for 404 */}
        <Route path='*' element={<NotFound />} />
      </Routes>
      <Toaster richColors position='top-right' />
    </Suspense>
  )
}
